import getFormattedClassnames from 'utils/getFormattedClassnames';
import breakpoints from 'utils/breakpoints';
import { componentProvider } from 'js-component-framework';
import Carousel from './carousel';
import moduleStyles from './carousel.module.scss';
import './carousel.scss';

const carouselClassnames = sciencenewsClassnames.carousel;
const carouselSelectors = getFormattedClassnames(carouselClassnames);

/* eslint-disable global-require, import/no-dynamic-require, import/no-webpack-loader-syntax */
const previous = require('!svg-inline-loader!./previous.svg');
const next = require('!svg-inline-loader!./next.svg');
/* eslint-enable */

const CarouselConfig = {
  name: 'carousel',
  component: Carousel,
  querySelector: {
    swiper: '.swiper',
    controlsWrapper: carouselSelectors.controlsWrapper,
  },
  querySelectorAll: {
    slides: carouselSelectors.wrapper,
  },
  options: {
    perPage: {
      320: 1,
      768: 2,
      1024: 4,
    },
    draggable: ! breakpoints.lgMin.matches,
    icons: {
      previous,
      next,
    },
    moduleStyles,
  },
};

componentProvider(CarouselConfig);
export default CarouselConfig;
